import { keysToCamel, keysToSnake } from '#/api/adapters/wireCase';
import request from '#/utils/request';

/**
 * Split 成功 envelope（頂層 source＋splits，無一般 data wrapper）。
 * @param {object} raw
 * @returns {{ message?: string, route?: string, source: object, splits: object[] }}
 */
export function parseInventoryStockSplitResponse(raw) {
  return {
    message: raw?.message,
    route: raw?.route,
    source: keysToCamel(raw?.source ?? {}),
    splits: keysToCamel(raw?.splits ?? []),
  };
}

/**
 * 庫存拆分。
 * body：`{ splits: number[], updatedAt }` → snake；**不可**指定 stockNo。
 *
 * @param {string} id
 * @param {{ splits: number[], updatedAt: string }} payload
 */
export async function splitInventoryStock(id, payload) {
  const { data: raw } = await request.post(
    `/inv/inventory-stock/${id}/split`,
    keysToSnake({
      splits: payload?.splits ?? [],
      updatedAt: payload?.updatedAt,
    }),
  );
  return parseInventoryStockSplitResponse(raw);
}
